/**
 * @see mockMd/union_city_war_rules.md
 */
import {storiesRewardIcon} from '../components/RulesPage/stories-images'
import {
  UnionCityWarStage,
  UnionCityWarTier,
  type UnionCityWarRankRewardItem,
  type UnionCityWarRewardItem,
  type UnionCityWarRulesData,
} from '../types'

const MOCK_REWARD_DESC_NAME = 'Avatar Frame*3d'
const MOCK_REWARD_ICON = storiesRewardIcon
/** 与首页 building_rewards 城建值展示项一致 @see mockMd/union_city_war_homepage.md */
const CITY_SCORE_ICON = 'https://img01.mehiya.com/imgv2/png/id/173698800235'

function makeReward(
  id: number,
  overrides: Partial<UnionCityWarRewardItem> = {}
): UnionCityWarRewardItem {
  return {
    id,
    name: 'Avatar Frame',
    view_icon: MOCK_REWARD_ICON,
    toast_name: MOCK_REWARD_DESC_NAME,
    reward_type: 1,
    tag: `level_A_${id}`,
    quantity: 3,
    reward_value: 100,
    has_show_effect: true,
    days: 3,
    ...overrides,
  }
}

/** 有奖励城建值时追加在该等级 `rewards` 末尾 */
function makeCityScoreReward(
  id: number,
  quantity: number
): UnionCityWarRewardItem {
  return {
    id,
    name: '城建值{0}',
    view_icon: CITY_SCORE_ICON,
    toast_name: '城建值{0}',
    reward_type: 1,
    tag: '',
    quantity,
    reward_value: 0,
    has_show_effect: false,
  }
}

function makeRankRewards(): UnionCityWarRankRewardItem[] {
  return [
    {
      rank_range: '1',
      threshold_a: 100000,
      threshold_b: 50000,
      threshold_c: 20000,
      coin_a: 10000000,
      coin_b: 5000000,
      coin_c: 2000000,
      reward_list: [makeReward(11001, {tag: 'stage_rank1'})],
    },
    {
      rank_range: '2,3',
      threshold_a: 80000,
      threshold_b: 40000,
      threshold_c: 15000,
      coin_a: 8000000,
      coin_b: 4000000,
      coin_c: 1500000,
      reward_list: [makeReward(11002, {tag: 'stage_rank2'})],
    },
    {
      rank_range: '4,10',
      threshold_a: 60000,
      threshold_b: 30000,
      threshold_c: 10000,
      coin_a: 6000000,
      coin_b: 3000000,
      coin_c: 1000000,
      reward_list: [makeReward(11003, {tag: 'stage_rank3'})],
    },
  ]
}

/** @see mockMd/union_city_war_rules.md · 对齐规则页 Tab1/Tab2 稿面可见条数 */
export const UnionCityWarRulesMock: UnionCityWarRulesData = {
  err_msg: '',
  tier: UnionCityWarTier.A,
  stage_list: [
    {
      stage: UnionCityWarStage.Group,
      time_range: '04.06-04.12',
      direct_promote_level: 20,
      promote_count: 10,
      rank_reward_list: makeRankRewards(),
      topn: 10,
    },
    {
      stage: UnionCityWarStage.Promotion,
      time_range: '04.13-04.19',
      direct_promote_level: 30,
      promote_count: 8,
      rank_reward_list: makeRankRewards(),
      topn: 10,
    },
    {
      stage: UnionCityWarStage.Final,
      time_range: '04.20-04.26',
      direct_promote_level: 40,
      promote_count: 5,
      rank_reward_list: makeRankRewards(),
      topn: 10,
    },
  ],
  anchor_threshold: 1000,
  pk_win_city_score: 5000,
  sign_city_score: 100,
  gift_reward_city_score: 200,
  core_rewards: [
    {
      level: 10,
      rewards: [
        makeReward(10001),
        makeReward(10002),
        makeReward(10003),
        makeReward(10004),
        makeCityScoreReward(30001, 1000),
      ],
    },
    {
      level: 20,
      rewards: [
        makeReward(10005),
        makeReward(10006),
        makeReward(10007),
        makeCityScoreReward(30002, 2000),
      ],
    },
    {
      level: 30,
      rewards: [
        makeReward(10008),
        makeReward(10009),
        makeCityScoreReward(30003, 3000),
      ],
    },
    {
      level: 40,
      rewards: [
        makeReward(10010),
        makeReward(10011),
        makeReward(10012),
        makeCityScoreReward(30004, 4000),
      ],
    },
    {
      level: 45,
      rewards: [
        makeReward(10013),
        makeReward(10014),
        makeReward(10015),
        makeCityScoreReward(30005, 4500),
      ],
    },
    {
      level: 50,
      rewards: [
        makeReward(10016),
        makeReward(10017),
        makeCityScoreReward(30006, 5000),
      ],
    },
  ],
}
